import { render, staticRenderFns } from "./OpenEnded.vue?vue&type=template&id=b15c1b34&scoped=true&"
import script from "./OpenEnded.vue?vue&type=script&lang=js&"
export * from "./OpenEnded.vue?vue&type=script&lang=js&"
import style0 from "./OpenEnded.vue?vue&type=style&index=0&id=b15c1b34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15c1b34",
  null
  
)

export default component.exports